import { Card, CardContent, Skeleton, Typography } from '@mui/material'

type Props = {
  title?: string
}
export const PieChartLoading = ({ title }: Props) => {
  return (
    <Card sx={{ height: '100%', minHeight: 350, boxShadow: 2, borderRadius: 2 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: '#2D3748',
            mb: 3,
          }}
        >
          {title}
        </Typography>
        <Skeleton variant="circular" width={250} height={250} sx={{ mx: 'auto' }} />
      </CardContent>
    </Card>
  )
}
